module.exports = __webpack_public_path__ + "img/1.87f54ace.webp";